import { mergeMap, tap } from 'rxjs/operators';
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryRealtimeParamsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import { selectDetailGsInStore, selectDetailGsPageLoading, selectDetailGsShowInitWaitingMessage } from '../_selectors/DetailG.selectors';


export class DetailGsDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
        super();

		this.loading$ = this.store.pipe(
			select(selectDetailGsPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectDetailGsShowInitWaitingMessage)
        );
        
        this.store.pipe(
			select(selectDetailGsInStore),
		).subscribe((response: QueryRealtimeParamsModel) => {
			// this.paginatorTotalSubject.next(response.totalCount);			
			this.entitySubject.next(response.items);
		});

    }
}